import {getSingleActiveItemObjectOnPage} from '@Components/poster-editor/poster-editor-reducer';
import type {SlideshowItem} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {ImageSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/image-slide-item.class';
import {useAppSelector} from '@/hooks';

interface UseGetSlideShowItemWithSelectedImageSlideProps {
  activeItem: SlideshowItem;
  activeSlide: ImageSlideItem;
}

export function useGetSlideShowItemWithSelectedImageSlide(): UseGetSlideShowItemWithSelectedImageSlideProps {
  const singleActiveItem = useAppSelector((state) => {
    return getSingleActiveItemObjectOnPage(state);
  });
  const activeItem = singleActiveItem ? window.posterEditor?.whiteboard?.getItemForId(singleActiveItem.uid) : null;

  if (!activeItem) {
    throw new Error(`Active item not found`);
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected the active item to be a slideshow item, instead got ${activeItem?.gitype}`);
  }

  const activeSlide = activeItem.getSelectedSlide();

  if (!activeSlide.isImageSlide()) {
    throw new Error(`Expected the active slide to be an image slide, instead got ${activeItem?.getSelectedSlide().gitype}`);
  }

  return {
    activeItem,
    activeSlide,
  };
}
